import { useNavigation } from "../../../hooks/useNavigation";
import { useCallback } from "react";
import { authActions } from "../../../ducks/auth";
import { PageRoute } from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";

export const useForgotPasswordPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { navigateToPage } = useNavigation();

    const handleForgotPassword = useCallback(
        (email: string, onError: (message: string) => void) => {
            dispatch(
                authActions.forgotPassword.started({
                    email,
                    onSuccess: () => {
                        navigateToPage(PageRoute.FORGOT_PASSWORD_SENT);
                    },
                    onError: (error) => {
                        // Try to extract a user-friendly error message
                        let message = "Failed to send reset link. Please try again.";

                        // Check for 404 status (email not found)
                        if (error?.response?.status === 404) {
                            message = "Email address not found. Please check your email and try again.";
                        } else if (typeof error?.response?.data === 'string') {
                            message = error.response.data;
                        } else if (error?.response?.data && typeof error.response.data === 'object') {
                            // Try to extract a code or details if available
                            const data = error.response.data as Record<string, unknown>;
                            if (data["error-code"]) {
                                message = String(data["error-code"]);
                            } else if (data.details) {
                                message = JSON.stringify(data.details);
                            } else if (data.message) {
                                message = String(data.message);
                            }
                        }
                        // Avoid showing raw Axios error messages like "Request failed with status code 404"

                        onError(message);
                    },
                })
            );
        },
        [dispatch, navigateToPage]
    );

    return { handleForgotPassword };
};
